import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './contexts/ThemeContext';
import { AdminProvider } from './contexts/AdminContext';
import Layout from './components/Layout/Layout';
import AdminLayout from './components/Admin/AdminLayout';
import ErrorBoundary from './components/UI/ErrorBoundary';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Industries from './pages/Industries';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Testimonials from './pages/Testimonials';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import AdminDashboard from './pages/Admin/AdminDashboard';
import ContentManager from './pages/Admin/ContentManager';
import ImageManager from './pages/Admin/ImageManager';
import BlogManager from './pages/Admin/BlogManager';
import LayoutManager from './pages/Admin/LayoutManager';
import AdminSettings from './pages/Admin/AdminSettings';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AdminProvider>
          <HelmetProvider>
            <Router>
              <Routes>
                {/* Admin Routes */}
                <Route path="/admin/*" element={
                  <AdminLayout>
                    <Routes>
                      <Route path="/" element={<AdminDashboard />} />
                      <Route path="/content" element={<ContentManager />} />
                      <Route path="/images" element={<ImageManager />} />
                      <Route path="/blog" element={<BlogManager />} />
                      <Route path="/layout" element={<LayoutManager />} />
                      <Route path="/settings" element={<AdminSettings />} />
                    </Routes>
                  </AdminLayout>
                } />

                {/* Public Routes */}
                <Route path="/*" element={
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/services" element={<Services />} />
                      <Route path="/industries" element={<Industries />} />
                      <Route path="/blog" element={<Blog />} />
                      <Route path="/blog/:slug" element={<BlogPost />} />
                      <Route path="/testimonials" element={<Testimonials />} />
                      <Route path="/contact" element={<Contact />} />
                      {/* 404 Catch-all Route */}
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </Layout>
                } />
              </Routes>
            </Router>
          </HelmetProvider>
        </AdminProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
